<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M32 5a27 27 0 1027 27A27 27 0 0032 5zm0 51a24 24 0 1124-24 24 24 0 01-24 24z"/><path d="M45.44 22.44L30.5 37.38l-8.94-8.94a1.5 1.5 0 00-2.12 2.12l9.65 9.65a2 2 0 002.82 0l15.65-15.65a1.5 1.5 0 00-2.12-2.12z"/></svg>